export enum ChatsRouteEvent {
  AssignToMeButtonClicked = 'Assign to me button clicked',
  ApplicationsBannerAppButtonClicked = 'Applications banner app clicked',
  BanCustomerButtonClicked = 'Ban customer button clicked',
  CloseAndArchiveButtonClicked = 'Chat closed and archived',
  CreateTicketButtonClicked = 'Create a ticket button clicked',
  SendTranscriptButtonClicked = 'Send transcript button clicked',
  StartChatButtonClicked = 'Chat started',
  StopChatButtonClicked = 'Stop chat button clicked',
  CloseChatButtonClicked = 'Close chat button clicked',
  StopSupervisingButtonClicked = 'Stop supervising button clicked',
  TakeOverChatButtonClicked = 'Take over chat button clicked',
  TransferButtonClicked = 'Transfer button clicked',
  ChatMenuOpened = 'Chat menu opened',
  InstallCode = 'Install code empty state clicked',
  InviteDeveloperClicked = 'Empty state invite developer clicked',
  GoToTeamClicked = 'Empty state go to team clicked',
  SeeAllChannelsClicked = 'Empty state see all channels clicked',
  TrafficSectionOpened = 'Traffic section opened',
  RetryMessageLinkClicked = 'Retry message link clicked',
  PrivateModeChange = 'Private mode change',
  ShortcutUsed = 'Shortcut used',
  ChatListSorted = 'Chat list sorted',
  GetMoreChatsClicked = 'Get more chats clicked',
  HelpDeskBannerClosed = 'HelpDesk banner closed',
  HelpDeskBannerLearnMoreClicked = 'HelpDesk banner learn more click',
  TagChatUsed = 'Tag chat used',
  UploadFileUsed = 'Upload file used',
  OpenArchivesFilterUsed = 'Open archives filter used',
}

export enum ChatOrigin {
  Checklist = 'checklist',
  NavigationBar = 'navigation bar',
  ChatsEmptyState = 'chats empty state',
}
